<template>
  <div class="wrapper">
    <password-reset-request-form
      :title="$t('app.help.forgotPassword')"
      :blurb="$t('app.help.forgotPasswordBlurb')"
      :input-field-default="$t('app.help.forgotPwDefault')"
      :status-message="changeRequestMessage"
      @forgot="handleRequestPasswordReset($event)"
    />
  </div>
</template>

<script>
import PasswordResetRequestForm from '@/app/components/PasswordResetRequestForm';
import { helpService } from '../help.service';
import { userUtils } from '@/mixins/user-utils';
export default {
  components: {
    PasswordResetRequestForm
  },
  mixins: [userUtils],
  data() {
    return {
      changeRequestMessage: null
    };
  },
  methods: {
    async handleRequestPasswordReset(evt) {
      const param = this.isValidEmail(evt) ? { email: evt } : { username: evt };
      const pwRequestResult = await helpService.requestPasswordReset(param);
      this.changeRequestMessage = pwRequestResult.pwResetCode
        ? this.$t('app.help.changeRequestSuccessMessage')
        : this.$t('app.help.changeRequestErrorMessage', {
            usernameOrEmail: Object.keys(param)[0]
          });
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.wrapper {
  background-color: $white;
  padding: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
